import PubSub from 'pubsub-js';
import Swiper, { Pagination, Autoplay, EffectFade } from 'swiper';

const headerCarousel = {
  init() {
    this.$carousel = document.querySelector('section.header_carousel');
    this.swiper = null;

    if (this.$carousel !== null) {
      this.destroyBinded = this.destroy.bind(this);
      this.resizeHandlerBinded = this.resizeHandler.bind(this);
      this.setUpListeners();
      this.setUpCarousel();
    }
  },

  setUpListeners() {
    PubSub.subscribe('page.transitionMiddle', this.destroyBinded);
    window.addEventListener('resize', this.resizeHandlerBinded);
  },

  lastWidth: window.innerWidth,
  resizeTimeout: null,
  resizeHandler() {
    if (this.lastWidth !== window.innerWidth) {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.destroyCarousel();
        this.setUpCarousel();
      }, 300);
    }
  },

  setUpCarousel() {
    console.log('Header carousel module found. Init carousel.');
    const $allSlides = this.$carousel.querySelectorAll('.swiper-slide');

    this.swiper = new Swiper(this.$carousel.querySelector('.swiper'), {
      modules: [Pagination, Autoplay, EffectFade],
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: false
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 500,
      loop: true,
      slidesPerView: 1
    });

    this.swiper.once('slideChange', () => {
      this.$carousel
        .querySelectorAll('.title, .cta')
        .forEach($el => $el.classList.remove('slide-in'));
    });
  },

  destroyCarousel() {
    this.swiper.destroy();
  },

  destroy() {
    PubSub.unsubscribe('page.transitionMiddle', this.destroyBinded);
    window.removeEventListener('resize', this.resizeHandlerBinded);
    this.destroyCarousel();
  }
};

PubSub.subscribe('page.inDOM', headerCarousel.init.bind(headerCarousel));

export default headerCarousel;